export const getPercetageValue = (target: number, actual: number, exact: boolean = false) => {
  if (actual === 0 || target === 0) {
    return 0;
  }

  let percentageValue = (actual / target) * 100;

  // Avoid trimming decimal if not asked
  if (!exact) {
    percentageValue = Math.floor(percentageValue);
  }

  return Math.min(percentageValue, 100);
};
